import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportRoute extends Schema {
    @type("number")
    @defaultValue(0)
    index: number;
    @type("boolean")
    @defaultValue(false)
    unlocked: boolean;
    @type("number")
    @defaultValue(0)
    demand: number;
    @type("number")
    @defaultValue(0)
    demandClock: number;
    @type("number")
    @defaultValue(0)
    flights: number;
}
